module.exports = __webpack_public_path__ + "media/images/tmp/slide4-78740b6d28de9a5cbd9117d5a63d6dab.jpg";